import type { FaireProductEntity } from "../../entity_types/product";

export const p_b2nxya6pih: FaireProductEntity = {
  token: "p_b2nxya6pih",
  type: "product",
  name: "Sending Love Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/7a4fac076df6940214eae9e0f35b7a65c3bde6733dcfec252cee8d32d2fb0a15.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4b5676c801758d193591fecf014fa013aee94002db6074c3139d88598b2b737c.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:23.188Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
